import React from 'react';
const IconMiscHandFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 14.84H3.02C3.13 16.62 3.79 18.34 4.91 19.73C6.57 21.81 9.04 23 11.7 23H15C18.31 23 21 20.31 21 17V7H19V11.81L17 11.46V3H15V11.1L13 10.75V1H11V10.4L9 10.05V2H7V13.51L5 13.16V10H3V14.84Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscHandFill;